import { inverseAnalysisQuestionContextText } from '@/question/class/Question'

// 用于将 题干中的 ${{xxxx}}内容 转换为对应的文字显示出来
export function convertAnswerText(text, answerContentList) {
  let result = null
  let resText = text
  while ((result = inverseAnalysisQuestionContextText.exec(text))) {
    let id = result[1]
    let ac = answerContentList.find(ac => ac.questonId === id)
    if (ac) {
      let items = ac.items
      resText = resText.replace(result[0], items.map(item => item.value).join(','))
    } else {
      resText = resText.replace(result[0], '')
    }
  }
  text = resText
  return text
}
